(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["icon"] = factory();
	else
		root["icon"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "../icon/src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../icon/src/icons/add_user.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function AddUser (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("ellipse",{"id":"XMLID_100_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"6.9","rx":"4","ry":"4","key":0}),React.createElement("path",{"id":"XMLID_46_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.2,14.1c0,0,0.4-3.3-1.2-3.3h-1.4c-0.6,0-0.7,0.3-0.8,0.4c-0.5,1-1.6,1.5-2.7,1.5H6.9c-1.1,0-2.3-0.5-2.7-1.5\n\t\tc-0.1-0.1-0.2-0.4-0.8-0.4H2c-1.6,0-1.2,3.3-1.2,3.3s1.3,0.8,7.2,0.8S15.2,14.1,15.2,14.1z","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.6","y1":"2.9","x2":"15.1","y2":"2.9","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"13.4","y1":"1.1","x2":"13.4","y2":"4.6","key":3})]));
}

AddUser.displayName = "AddUser";

AddUser.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = AddUser;

AddUser.default = AddUser;


/***/ }),

/***/ "../icon/src/icons/alarm.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Alarm (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM12.6,4.8v2.2c0,0.2,0.1,0.7,0.1,0.8l1,3.5c0.4,1.1-0.2,2.4-1.4,2.4H3.6c-1.2,0-1.8-1.3-1.4-2.4l1-3.5C3.3,7.7,3.4,7.3,3.4,7V4.8\n\t\tc0-1.7,0.7-2.3,2.2-2.9C6.3,1.6,7.2,0.5,8,0.5s1.6,1,2.2,1.2C11.8,2.4,12.6,3.2,12.6,4.8z","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.6,13.8c0,0.9,1.2,1.7,2.4,1.7c1.2,0,2.4-0.8,2.4-1.7","key":1})]));
}

Alarm.displayName = "Alarm";

Alarm.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Alarm;

Alarm.default = Alarm;


/***/ }),

/***/ "../icon/src/icons/application.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Application (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13.2,15.5H2.8c-1.2,0-2.3-1-2.3-2.3V2.8c0-1.2,1-2.3,2.3-2.3h10.5c1.2,0,2.3,1,2.3,2.3v10.5C15.5,14.5,14.5,15.5,13.2,15.5z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"5.8","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"1.4","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t14.8,14.8 8,0.6 1.2,14.8 \t","key":3}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t5.5,10.5 8,12 10.5,10.5 \t","key":4})]));
}

Application.displayName = "Application";

Application.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Application;

Application.default = Application;


/***/ }),

/***/ "../icon/src/icons/archive.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Archive (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"1.6","y":"3.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"12.8","height":"11.2","key":0}),React.createElement("rect",{"x":"0.8","y":"1.5","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"14.4","height":"1.8","key":1}),React.createElement("rect",{"x":"4","y":"5.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"8","height":"6","key":2})]));
}

Archive.displayName = "Archive";

Archive.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Archive;

Archive.default = Archive;


/***/ }),

/***/ "../icon/src/icons/arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.4,8 9.4,6 9.4,8 9.4,10 \t","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.4","y1":"8","x2":"2.6","y2":"8","key":1})]));
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Arrow;

Arrow.default = Arrow;


/***/ }),

/***/ "../icon/src/icons/at.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function At (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4,5.7","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.7,8c0,2.2-1.2,4-2.7,4s-2.7-1.8-2.7-4S6.5,4,8,4S10.7,5.8,10.7,8z","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.7,8L10.7,8c0,2,2.3,4.6,3.8,3.1c0.5-0.5,0.9-2.4,0.9-3.1c0-4.1-3.4-7.4-7.5-7.4C4,0.7,0.7,4,0.6,7.9C0.6,12,3.9,15.4,8,15.4\n\t\tc1.5,0,3-0.5,4.1-1.3","key":2})]));
}

At.displayName = "At";

At.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = At;

At.default = At;


/***/ }),

/***/ "../icon/src/icons/bitbucket.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Bitbucket (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"7.9","cy":"8.4","r":"1.4","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM0.8,1.7L2.3,14c0.1,0.6,0.6,1.1,1.2,1.1h8.7c0.6,0,1.1-0.5,1.2-1.1l1.8-12.3","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"7.9","cy":"8.4","r":"2.7","key":2}),React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"1.7","rx":"7.2","ry":"0.8","key":3}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM13.5,13.5c0,0.4-2.5,0.7-5.7,0.7s-5.7-0.3-5.7-0.7","key":4}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM7.9,11","key":5})]);
}

Bitbucket.displayName = "Bitbucket";

Bitbucket.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Bitbucket;

Bitbucket.default = Bitbucket;


/***/ }),

/***/ "../icon/src/icons/burgerMenu.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function BurgerMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"2.2","x2":"13.9","y2":"2.2","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"13.8","x2":"13.9","y2":"13.8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"7.9","x2":"13.9","y2":"7.9","key":2})]));
}

BurgerMenu.displayName = "BurgerMenu";

BurgerMenu.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;


/***/ }),

/***/ "../icon/src/icons/cards.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Cards (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"0.5","y":"0.5","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":0}),React.createElement("rect",{"x":"10","y":"0.5","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":1}),React.createElement("rect",{"x":"10","y":"10","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":2}),React.createElement("rect",{"x":"0.5","y":"10","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"5.4","height":"5.4","key":3})]));
}

Cards.displayName = "Cards";

Cards.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Cards;

Cards.default = Cards;


/***/ }),

/***/ "../icon/src/icons/checkMark.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function CheckMark (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t12.9,3.8 4.5,12.2 3.1,9.4 "}));
}

CheckMark.displayName = "CheckMark";

CheckMark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = CheckMark;

CheckMark.default = CheckMark;


/***/ }),

/***/ "../icon/src/icons/cluster.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Cluster (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.6,4.3 1.6,11.7 8,15.4 14.4,11.7 14.4,4.3 8,0.6 \t","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.5,6 4.5,10 8,12 11.5,10 11.5,6 8,4 \t","key":1}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.8,7.3 6.8,8.7 8,9.3 9.2,8.7 9.2,7.3 8,6.7 \t","key":2})]));
}

Cluster.displayName = "Cluster";

Cluster.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Cluster;

Cluster.default = Cluster;


/***/ }),

/***/ "../icon/src/icons/code.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Code (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t12,5.9 15.5,7.9 12,9.9 \t","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4,9.9 0.5,7.9 4,5.9 \t","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.6","y1":"2.2","x2":"4.4","y2":"13.8","key":2})]));
}

Code.displayName = "Code";

Code.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Code;

Code.default = Code;


/***/ }),

/***/ "../icon/src/icons/comment.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Comment (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM0.8,14.9l7.1-3.1h3c2.4,0,4.3-1.9,4.3-4.3V5.3c0-2.4-1.9-4.3-4.3-4.3H5.1C2.7,1.1,0.8,3,0.8,5.3v2.2c0,0.1,0,0.2,0,0.3\n\tc0.1,0.8,0.3,1.6,0.8,2.3L0.8,14.9z"}));
}

Comment.displayName = "Comment";

Comment.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Comment;

Comment.default = Comment;


/***/ }),

/***/ "../icon/src/icons/copyClipboard.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function CopyClipboard (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t12.5,6.5 12.5,15 1.7,15 1.7,1 6.5,1 \t","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.4","y1":"7.7","x2":"9.8","y2":"7.7","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.4","y1":"5.7","x2":"7.1","y2":"5.7","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.4","y1":"9.8","x2":"9.8","y2":"9.8","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.4","y1":"11.8","x2":"9.7","y2":"11.8","key":4}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.6,3.4 10.6,5.5 10.6,3.5 10.6,1.5 \t","key":5}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"10.6","y1":"3.7","x2":"14.3","y2":"3.7","key":6})]));
}

CopyClipboard.displayName = "CopyClipboard";

CopyClipboard.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = CopyClipboard;

CopyClipboard.default = CopyClipboard;


/***/ }),

/***/ "../icon/src/icons/cpu.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Cpu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"XMLID_161_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,9.9","key":0}),React.createElement("path",{"id":"XMLID_138_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,10.9","key":1}),React.createElement("g",{"key":2},[React.createElement("rect",{"x":"2.6","y":"2.1","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"10.6","height":"11.8","key":0}),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"15.1,14.2 \n\t\t\t\t\t15.1,15.2 14.1,15.2 \t\t\t\t","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.75,1.75","x1":"12.4","y1":"15.2","x2":"2.8","y2":"15.2","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"1.9,15.2 \n\t\t\t\t\t0.9,15.2 0.9,14.2 \t\t\t\t","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7857,1.7857","x1":"0.9","y1":"12.5","x2":"0.9","y2":"2.6","key":3}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"0.9,1.8 \n\t\t\t\t\t0.9,0.8 1.9,0.8 \t\t\t\t","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.75,1.75","x1":"3.6","y1":"0.8","x2":"13.2","y2":"0.8","key":5}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"14.1,0.8 \n\t\t\t\t\t15.1,0.8 15.1,1.8 \t\t\t\t","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7857,1.7857","x1":"15.1","y1":"3.5","x2":"15.1","y2":"13.4","key":7})]))])]));
}

Cpu.displayName = "Cpu";

Cpu.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Cpu;

Cpu.default = Cpu;


/***/ }),

/***/ "../icon/src/icons/delete.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM4.4,16.1","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM2.9,7.9","key":1}),React.createElement("g",{"key":2},[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.1,15.1","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4.4,15.2l7.2,0c1,0,1.8-0.8,1.8-1.8V4.3l1.8,0l0-2.1l-5.5,0l0-1.4H6.3l0,1.4l-5.5,0l0,2.1h1.8v9.1C2.6,14.4,3.4,15.2,4.4,15.2z","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"4.9","x2":"8","y2":"12.8","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.3","y1":"5.3","x2":"5.3","y2":"12","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"10.7","y1":"5.4","x2":"10.7","y2":"12","key":4})])]);
}

Delete.displayName = "Delete";

Delete.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Delete;

Delete.default = Delete;


/***/ }),

/***/ "../icon/src/icons/devCenter.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function DevCenter (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM1.1,0.7h6.5c4.1,0,7.4,3.3,7.3,7.4c-0.1,3.9-3.3,7.2-7.2,7.2l-6.6,0V0.7z","key":0}),React.createElement("path",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM10.3,5C8.7,3.4,6.2,3.4,4.6,5s-1.6,4.1,0,5.7s4.1,1.6,5.7,0L7.4,7.8L10.3,5z","key":1})]));
}

DevCenter.displayName = "DevCenter";

DevCenter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = DevCenter;

DevCenter.default = DevCenter;


/***/ }),

/***/ "../icon/src/icons/docs.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Docs (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"4","x2":"11.4","y2":"4","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"8","x2":"8.1","y2":"8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.3","y1":"12","x2":"6.8","y2":"12","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.5,0.8 0.9,0.8 0.9,15.2 \t","key":3}),React.createElement("polygon",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15.1,8 8,8 8,15.2 \t","key":4})]));
}

Docs.displayName = "Docs";

Docs.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Docs;

Docs.default = Docs;


/***/ }),

/***/ "../icon/src/icons/download.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.2,11c-1.4-0.3-2.4-1.7-2.4-3.1c0-1.6,1.3-3,2.8-3.1c0,0,0-0.1,0-0.1c-0.1-2,1.5-3.6,3.5-3.6c0,0,0,0,0.1,0\n\t\tc2.5,0,3.4,1.9,3.4,1.9l0,0c0.2,0,0.4-0.1,0.6-0.1c2.2,0,4,1.9,4,4.1c0,2-1.5,3.6-3.4,3.9","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.2,14.9 9.2,11 5.2,11 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"5.6","x2":"7.2","y2":"10.8","key":2})]));
}

Download.displayName = "Download";

Download.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Download;

Download.default = Download;


/***/ }),

/***/ "../icon/src/icons/edit.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"opacity":"0.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.2,15.3","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t14.3,2.5 14.3,0.7 6.5,0.7 2.5,3.9 2.5,9.7 \t","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.2,15.1 14.3,15.1 14.3,7.9 \t","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.5,3.9 6.5,3.9 6.5,0.7 \t","key":3}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.1,13.6 3.2,14.7 6.4,13.1 3.6,10.4 \t","key":4}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.4,13.1 14.2,5.4 11.3,2.7 3.6,10.4 \t","key":5}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.7,15.1 3.2,14.7 2.1,13.6 \t","key":6})]));
}

Edit.displayName = "Edit";

Edit.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Edit;

Edit.default = Edit;


/***/ }),

/***/ "../icon/src/icons/environment.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Environment (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.7,12.7","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM0.6,7.5c0.2-0.5,1.2-2.2,3.8-3c0,0,0.5-2.9,3.5-3.9","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.4,8c0,0-0.2-2.1-3.9-3.4c-2.8-1-5.4,1.2-5.4,1.2c-2.5,2-1.8,5.6-1.8,5.6c2.9,1.1,5.5-1.4,5.5-1.4c0.6-0.7,1-1.3,1.3-1.9\n\t\tc0.1,0.1,0.8,1.4,0.2,3.2c-0.6,1.7-1.7,3.2-2.9,3.9","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.3,2.2c0,0-0.6,0.8-0.5,1.8l2.5-1.2C10.3,2.7,9.2,2.2,8.3,2.2z","key":3}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.7,14.9c0,0,0.8-1,0.8-1.1c0,0-2-0.2-2.2-0.5s0.4,0.5,0.4,0.5S6.6,14.9,6.7,14.9z","key":4}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"7.4","key":5})]));
}

Environment.displayName = "Environment";

Environment.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Environment;

Environment.default = Environment;


/***/ }),

/***/ "../icon/src/icons/exclamationMarkSolid.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function ExclamationMarkSolid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M7.1,1.3h1.8c0.9,0,1.7,0.8,1.5,1.8L9.6,9.7c-0.2,0.6-0.8,1-1.5,1h0c-0.7,0-1.2-0.4-1.5-1L5.5,3.1\n\tC5.4,2.2,6.1,1.3,7.1,1.3z","key":0}),React.createElement("circle",{"fill":"currentColor","cx":"8","cy":"13.3","r":"1.4","key":1})]);
}

ExclamationMarkSolid.displayName = "ExclamationMarkSolid";

ExclamationMarkSolid.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = ExclamationMarkSolid;

ExclamationMarkSolid.default = ExclamationMarkSolid;


/***/ }),

/***/ "../icon/src/icons/exclamationmark.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Exclamationmark (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.1,1.3h1.8c0.9,0,1.7,0.8,1.5,1.8L9.6,9.7c-0.2,0.6-0.8,1-1.5,1h0c-0.7,0-1.2-0.4-1.5-1L5.5,3.1C5.4,2.2,6.1,1.3,7.1,1.3z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.3","r":"1.4","key":1})]));
}

Exclamationmark.displayName = "Exclamationmark";

Exclamationmark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Exclamationmark;

Exclamationmark.default = Exclamationmark;


/***/ }),

/***/ "../icon/src/icons/explore.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Explore (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.2,9.6c-1.1,1.7-3.3,4.2-7.2,4.2c-3.9,0-6.1-2.6-7.1-4.2","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"4","key":1}),React.createElement("path",{"fill":"currentColor","d":"M10,8c0,1.1-0.9,2-2,2S6,9.2,6,8s0.9-2,2-2v2H10z","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM0.3,7.7C0.8,6.5,2.9,2.2,8,2.2c4.7,0,7,4,7.7,5.5","key":3})]));
}

Explore.displayName = "Explore";

Explore.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Explore;

Explore.default = Explore;


/***/ }),

/***/ "../icon/src/icons/fail.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Fail (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.2,4.2C7.2,4.2,7.1,4.2,7.2,4.2c-2.1,0-3.7,1.8-3.6,3.8c0,0,0,0,0,0c0,0,0,0,0,0C2,8.1,0.8,9.4,0.8,11c0,1.7,1.3,3.1,3,3.1\n\t\tc0.1,0,7.4,0,7.4,0c1.4,0,2.6-0.7,3.3-1.8","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"10","x2":"15.2","y2":"2","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.2","y1":"10","x2":"7.2","y2":"2","key":2})]));
}

Fail.displayName = "Fail";

Fail.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Fail;

Fail.default = Fail;


/***/ }),

/***/ "../icon/src/icons/filtering.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Filtering (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM9.5,13.7l0.9-5.9c0-0.2,0.1-0.3,0.2-0.5L15.2,1H0.8l4.3,6.3c0.1,0.1,0.2,0.3,0.2,0.5l0.1,0.6L6.5,15L9.5,13.7z","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.3","y1":"7.9","x2":"8","y2":"7.9","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"6","y1":"11.9","x2":"8","y2":"11.9","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.9","y1":"3.9","x2":"8","y2":"3.9","key":3})]));
}

Filtering.displayName = "Filtering";

Filtering.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Filtering;

Filtering.default = Filtering;


/***/ }),

/***/ "../icon/src/icons/flag.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Flag (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t\t2.6,10 2.6,1.6 13.4,1.5 10.7,5.6 12.8,9.9 \t\t"})),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.6","y1":"15","x2":"2.6","y2":"1","key":1})]));
}

Flag.displayName = "Flag";

Flag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Flag;

Flag.default = Flag;


/***/ }),

/***/ "../icon/src/icons/github.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Github (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.8","y1":"11.6","x2":"10.9","y2":"15.5","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.2","y1":"15.5","x2":"6.2","y2":"11.7","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.1,13.7C1.5,12.4,0.5,10.3,0.5,8c0-4.1,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5c0,2.4-1.2,4.6-3,6","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM12.6,3.2l0,2.3c0.5,0.4,0.9,1,1.1,1.6l0,0c0.1,0.6,0.1,1.2,0,1.7l0,0c-0.3,1.2-1.2,2.1-2.4,2.4l-2.5,0.7c-0.5,0.1-1,0.1-1.5,0\n\t\tL5,11.3c-1.2-0.3-2.3-1.2-2.6-2.4l0-0.1c-0.1-0.5-0.1-1,0-1.5l0,0C2.4,6.6,2.9,6,3.4,5.5l0-2.3L8,4L12.6,3.2z","key":3}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t5.6,14.1 3.4,12.8 3.4,12 \t","key":4}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.7,4.2","key":5})]));
}

Github.displayName = "Github";

Github.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Github;

Github.default = Github;


/***/ }),

/***/ "../icon/src/icons/group.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Group (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"XMLID_220_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM14.6,11.8c0.8,0,0.6,2.3,0.6,2.3s-0.8,0.4-4.5,0.4H5.3c-3.7,0-4.5-0.3-4.5-0.3s-0.3-2.3,0.7-2.3","key":0}),React.createElement("path",{"id":"XMLID_214_","fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.8,12.7c0.4,0.3,0.9,0.4,1.3,0.4l1.5,0c0.7,0,1.5-0.3,1.8-1","key":1}),React.createElement("path",{"id":"XMLID_213_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.7,12c-0.3,0.7-1.1,1-1.8,1l-1.4,0c-0.7,0-1.5-0.3-1.8-0.9","key":2}),React.createElement("path",{"id":"XMLID_212_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.3,10.9c-0.5,0.5-1.2,0.9-2,0.9c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7c0.8,0,1.4,0.3,1.9,0.8C7.7,7.6,8,8.3,8,9.1","key":3}),React.createElement("path",{"id":"XMLID_211_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.8,7.2c0.5-0.5,1.2-0.8,1.9-0.8c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7S8,10.6,8,9.1","key":4}),React.createElement("path",{"id":"XMLID_210_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.4,5C5.3,4.8,5.3,4.6,5.3,4.3c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7c0,0.2,0,0.5-0.1,0.7","key":5})]));
}

Group.displayName = "Group";

Group.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Group;

Group.default = Group;


/***/ }),

/***/ "../icon/src/icons/ideasBox.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function IdeasBox (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.6,6.5c0-0.8,0.7-1.3,1.4-1.3s1.4,0.5,1.4,1.3","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM11.8,9c0.6-0.9,0.8-2,0.7-3.2C12.1,4.1,10.7,2.6,9,2.3C6.1,1.7,3.6,3.8,3.6,6.6c0,0.9,0.3,1.8,0.8,2.5c0.5,0.7,0.9,1.3,1.3,2.1\n\t\tl0.8,1.6l3.2,0l0.9-1.7C10.9,10.3,11.3,9.7,11.8,9z","key":1}),React.createElement("g",{"key":2},React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","d":"M14.1,6.5\n\t\t\t\tc0-0.5-0.1-1-0.2-1.5","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"3.2036,3.2036","d":"\n\t\t\t\tM12.4,2.2C11.3,1.1,9.7,0.4,8,0.4c-2.3,0-4.2,1.2-5.3,3.1","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","d":"M2.2,5\n\t\t\t\tC2,5.5,2,6,2,6.5","key":2})])),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,11.3c1.4-1.2,2.6-3,2.6-4.8","key":3}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,12.7","key":4}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.6,6.5c0,1.7,1.3,3.6,2.6,4.8","key":5}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.4,12.8 5.5,13.2 6.4,15.2 8,15.2 9.6,15.2 10.5,13.2 9.7,12.7 \t","key":6}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.6,15.3 7.8,15.6 8.2,15.6 8.4,15.3 \t","key":7})]));
}

IdeasBox.displayName = "IdeasBox";

IdeasBox.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = IdeasBox;

IdeasBox.default = IdeasBox;


/***/ }),

/***/ "../icon/src/icons/learn.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Learn (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.8,2.6","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,3.5","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.9,4.1","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,4.8","key":3}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.8,6.6","key":4}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,7.5","key":5}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.9,8.1","key":6}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,8.8","key":7}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.8,10.6","key":8}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,11.5","key":9}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM6.9,12.8","key":10}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.4,1.1 15.2,0.6 15.2,15 8,15.4 \t","key":11}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.2,2.2","key":12}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.5,1.1 0.8,0.7 0.8,15 8,15.4 \t","key":13}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t8,2.1 13.4,0.6 13.4,13.8 8,15.4 2.5,13.8 2.5,0.6 8,2.1 \t","key":14}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.2,15.5","key":15}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM2.8,13.8","key":16}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"2.2","x2":"8","y2":"15.4","key":17}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM11,3.8L11,3.8c-0.5,0-1,0.4-1,1l0,2.1c0,0.5,0.4,1,1,1h0c0.5,0,1-0.4,1-1V4.8C12,4.3,11.5,3.8,11,3.8z","key":18}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4,3.8L4,3.8l0,2C4,7,4.9,7.8,6,7.8h0V5.8C6,4.7,5.1,3.8,4,3.8z","key":19}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4","y1":"11.8","x2":"6.4","y2":"11.8","key":20}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4","y1":"9.8","x2":"6.4","y2":"9.8","key":21}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.6","y1":"11.8","x2":"12","y2":"11.8","key":22}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.6","y1":"9.8","x2":"12","y2":"9.8","key":23})]));
}

Learn.displayName = "Learn";

Learn.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Learn;

Learn.default = Learn;


/***/ }),

/***/ "../icon/src/icons/links.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Links (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.5,4.7","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM11.2,6.1c0,0-1.1-1.9-3.2-1.9S4.7,5.8,4.7,5.8L1.6,9.2c-1.4,1.4-1.4,3.8,0,5.2s3.8,1.4,5.2,0l0.9-0.8","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4.8,9.9c0,0,1.1,1.9,3.2,1.9s3.4-1.5,3.4-1.5l3.1-3.4c1.4-1.4,1.4-3.8,0-5.2s-3.8-1.4-5.2,0L8.3,2.4","key":2})]));
}

Links.displayName = "Links";

Links.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Links;

Links.default = Links;


/***/ }),

/***/ "../icon/src/icons/list.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function List (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM14.5,4.2","key":0}),React.createElement("rect",{"x":"6.9","y":"0.9","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"8.6","height":"3.5","key":1}),React.createElement("rect",{"x":"6.9","y":"6.3","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"8.6","height":"3.5","key":2}),React.createElement("rect",{"x":"6.9","y":"11.6","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"8.6","height":"3.5","key":3}),React.createElement("rect",{"x":"0.5","y":"0.9","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"3.5","height":"3.5","key":4}),React.createElement("rect",{"x":"0.5","y":"6.3","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"3.5","height":"3.5","key":5}),React.createElement("rect",{"x":"0.5","y":"11.6","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"3.5","height":"3.5","key":6})]);
}

List.displayName = "List";

List.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = List;

List.default = List;


/***/ }),

/***/ "../icon/src/icons/location.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13.8,6.9c0-3.2-2.6-5.8-5.8-5.8S2.2,3.7,2.2,6.9c0,2,1,3.7,2.5,4.8l3.3,3.1l4.1-3.9C13.2,10,13.8,8.5,13.8,6.9z","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.5,5 4.5,9 8,11 11.5,9 11.5,5 8,3 \t","key":1}),React.createElement("polygon",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.8,6.3 6.8,7.7 8,8.4 9.2,7.7 9.2,6.3 8,5.6 \t","key":2})]));
}

Location.displayName = "Location";

Location.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Location;

Location.default = Location;


/***/ }),

/***/ "../icon/src/icons/logout.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Logout (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t11.4,14.7 0.8,14.8 0.8,1.3 11.4,1.3 \t","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15.2,8 11.1,6 11.2,8 11.1,10 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.1","y1":"8","x2":"4.3","y2":"8","key":2})]));
}

Logout.displayName = "Logout";

Logout.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Logout;

Logout.default = Logout;


/***/ }),

/***/ "../icon/src/icons/machineType.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function MachineType (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.9,2.3","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.5","y1":"6.7","x2":"8.9","y2":"6.7","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.5","y1":"9.4","x2":"8.9","y2":"9.4","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.5","y1":"4","x2":"8.8","y2":"4","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.5","y1":"12.1","x2":"8.8","y2":"12.1","key":4}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t10.5,0.8 1.7,0.8 1.7,15.2 14.3,15.2 14.3,4.6 \t","key":5})]));
}

MachineType.displayName = "MachineType";

MachineType.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = MachineType;

MachineType.default = MachineType;


/***/ }),

/***/ "../icon/src/icons/marketplace.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Marketplace (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15.5,4 13,0.5 3.1,0.5 0.5,4 \t","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.5,5.4 1.5,15.5 14.6,15.5 14.5,5.4 \t","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.5","y1":"12","x2":"14.6","y2":"12","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,4","key":3}),React.createElement("rect",{"x":"3.4","y":"5.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"9.2","height":"5.4","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.6","y1":"1.3","x2":"13.4","y2":"1.3","key":5}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.4","y1":"12","x2":"3.4","y2":"15.5","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"12","x2":"8","y2":"15.5","key":7}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"12.6","y1":"12","x2":"12.6","y2":"15.5","key":8})]));
}

Marketplace.displayName = "Marketplace";

Marketplace.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Marketplace;

Marketplace.default = Marketplace;


/***/ }),

/***/ "../icon/src/icons/master.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Master (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.8","r":"1.4","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"2.2","r":"1.4","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.3","cy":"2.3","r":"1.4","key":2}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.5","cy":"2.2","r":"1.4","key":3}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.7","cy":"13.7","r":"1.4","key":4}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.3","cy":"13.7","r":"1.4","key":5}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.4","cy":"8","r":"1.4","key":6}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.6","cy":"8","r":"1.4","key":7}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"5.3","x2":"8","y2":"3.6","key":8}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"12.4","x2":"8","y2":"10.7","key":9}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4","y1":"8","x2":"5.3","y2":"8","key":10}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"10.7","y1":"8","x2":"12","y2":"8","key":11}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"2.7","key":12}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.4","y1":"12.6","x2":"6.1","y2":"9.9","key":13}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"6.1","y1":"6.1","x2":"3.4","y2":"3.4","key":14}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.9","y1":"6.1","x2":"12.7","y2":"3.4","key":15}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"10","y1":"9.9","x2":"12.7","y2":"12.7","key":16})]));
}

Master.displayName = "Master";

Master.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Master;

Master.default = Master;


/***/ }),

/***/ "../icon/src/icons/memory.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Memory (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("g",null,[React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"15.2,14.2 \n\t\t\t\t15.2,15.2 14.2,15.2 \t\t\t","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7679,1.7679","x1":"12.4","y1":"15.2","x2":"2.7","y2":"15.2","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"1.8,15.2 \n\t\t\t\t0.8,15.2 0.8,14.2 \t\t\t","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7857,1.7857","x1":"0.8","y1":"12.5","x2":"0.8","y2":"2.6","key":3}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"0.8,1.8 \n\t\t\t\t0.8,0.8 1.8,0.8 \t\t\t","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7679,1.7679","x1":"3.6","y1":"0.8","x2":"13.3","y2":"0.8","key":5}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","points":"14.2,0.8 \n\t\t\t\t15.2,0.8 15.2,1.8 \t\t\t","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"1.7857,1.7857","x1":"15.2","y1":"3.5","x2":"15.2","y2":"13.4","key":7})])),React.createElement("rect",{"x":"9.2","y":"2.2","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"4.4","height":"11.5","key":1}),React.createElement("rect",{"x":"2.7","y":"2.1","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"4.4","height":"11.6","key":2})]));
}

Memory.displayName = "Memory";

Memory.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Memory;

Memory.default = Memory;


/***/ }),

/***/ "../icon/src/icons/nodes.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Nodes (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#4A4A4A;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"8,6.2 5.5,4.8 5.5,1.9 8,0.5 10.5,1.9 10.5,4.8 \t","key":0}),React.createElement("polygon",{"className":"st0","points":"13,6.9 15.5,8.3 15.5,11.2 13,12.6 10.5,11.2 10.5,8.3 \t","key":1}),React.createElement("polygon",{"className":"st0","points":"3,6.9 5.5,8.3 5.5,11.2 3,12.6 0.5,11.2 0.5,8.3 \t","key":2}),React.createElement("polygon",{"className":"st0","points":"8,9.8 10.5,11.2 10.5,14.1 8,15.5 5.5,14.1 5.5,11.2 \t","key":3}),React.createElement("line",{"className":"st0","x1":"8","y1":"9.8","x2":"8","y2":"6.2","key":4}),React.createElement("polyline",{"className":"st0","points":"12,7.4 12,6 10.1,5 \t","key":5}),React.createElement("polyline",{"className":"st0","points":"4,7.5 4,6 5.9,5 \t","key":6})])]);
}

Nodes.displayName = "Nodes";

Nodes.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Nodes;

Nodes.default = Nodes;


/***/ }),

/***/ "../icon/src/icons/options.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Options (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},[React.createElement("circle",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"10.6","cy":"13.8","r":"1.3","key":0}),React.createElement("circle",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"4.1","cy":"8","r":"1.3","key":1}),React.createElement("circle",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8.1","cy":"2.2","r":"1.3","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\t\tM7.9,13.8","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.4","y1":"2.2","x2":"13.9","y2":"2.2","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"2.2","x2":"6.8","y2":"2.2","key":5}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"12","y1":"13.8","x2":"13.9","y2":"13.8","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.1","y1":"13.8","x2":"9.1","y2":"13.8","key":7}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.5","y1":"7.9","x2":"15.6","y2":"7.9","key":8})]),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"0.4","y1":"7.9","x2":"2.6","y2":"7.9","key":1})]));
}

Options.displayName = "Options";

Options.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Options;

Options.default = Options;


/***/ }),

/***/ "../icon/src/icons/organization.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Organization (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM14,4.3","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.1,2.5 4.1,13.5 7.5,15.5 11,13.5 11,2.5 7.5,0.5 \t","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.1,6 1,7.8 1,11.8 2.9,12.8 2.9,8.7 1,7.8 \t","key":2}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t15,6 12.1,7.3 12.1,12.9 15,11.2 15,6 11.1,4.6 \t","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.1","y1":"12.2","x2":"2.9","y2":"12.8","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.1","y1":"8","x2":"2.9","y2":"8.7","key":5}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.6,5.1","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"12.1","y1":"7.3","x2":"11.1","y2":"6.9","key":7}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t9.5,6.8 7.5,8 7.5,12 9.5,10.9 \t","key":8}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t5.9,3.6 7.5,4.5 7.5,8 5.9,7.1 \t","key":9}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.8,14 4.8,10.5 7.5,12 7.5,15.5 \t","key":10}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11","y1":"12.2","x2":"12.1","y2":"12.9","key":11})]));
}

Organization.displayName = "Organization";

Organization.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Organization;

Organization.default = Organization;


/***/ }),

/***/ "../icon/src/icons/padlock.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM2.6,5.2l0-0.5c0-2.2,1.8-4,4-4h3.1c2.2,0,4,1.8,4,4.1l0,0.4","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinejoin":"round","strokeMiterlimit":"10","points":"14.8,15.3 \n\t\t1.1,15.2 1.1,5.6 14.9,5.6 \t","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"9.6","r":"1.3","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"10.9","x2":"8","y2":"12.9","key":3})]));
}

Padlock.displayName = "Padlock";

Padlock.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Padlock;

Padlock.default = Padlock;


/***/ }),

/***/ "../icon/src/icons/pipeline.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Pipeline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.4","cy":"13.4","r":"1.4","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.6","cy":"13.4","r":"1.4","key":1}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.6","cy":"2.6","r":"1.4","key":2}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.4","cy":"2.6","r":"1.4","key":3}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"2.6","r":"1.4","key":4}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.4","cy":"8","r":"1.4","key":5}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.9","y1":"13.8","x2":"6.7","y2":"13.8","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.4","y1":"13.8","x2":"12","y2":"13.8","key":7}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t5.5,9.4 5.5,6.6 8,5.1 10.5,6.6 10.5,9.4 8,10.9 \t","key":8}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.4","r":"1.4","key":9}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.6,12 2.6,8 5.5,8 \t","key":10}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.4,6.5 13.4,5.2 13.4,4 \t","key":11}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.4,11.9 13.4,10.6 13.4,9.3 \t","key":12}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.9","y1":"2.2","x2":"6.4","y2":"2.2","key":13}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.5","y1":"2.2","x2":"12","y2":"2.2","key":14})]));
}

Pipeline.displayName = "Pipeline";

Pipeline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Pipeline;

Pipeline.default = Pipeline;


/***/ }),

/***/ "../icon/src/icons/plus.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.line{fill:none;stroke:currentColor;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("path",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M13.2,15.5H2.8c-1.2,0-2.3-1-2.3-2.3V2.8c0-1.2,1-2.3,2.3-2.3h10.5c1.2,0,2.3,1,2.3,2.3v10.4\n\tC15.5,14.5,14.5,15.5,13.2,15.5z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M8,8","key":2}),React.createElement("line",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","x1":"3.8","y1":"8","x2":"12.2","y2":"8","key":3}),React.createElement("line",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","x1":"8","y1":"3.8","x2":"8","y2":"12.2","key":4})]);
}

Plus.displayName = "Plus";

Plus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;


/***/ }),

/***/ "../icon/src/icons/refresh.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13,5c-1.6-2.7-5.1-3.7-7.9-2.1","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t14.8,8.6 11.2,5.9 13,5 14.8,4.1 \t","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3,11c1.6,2.7,5.1,3.7,7.9,2.1","key":2}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.2,7.4 4.8,10.1 3.1,11 1.2,11.9 \t","key":3})]));
}

Refresh.displayName = "Refresh";

Refresh.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Refresh;

Refresh.default = Refresh;


/***/ }),

/***/ "../icon/src/icons/releases.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Releases (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3","y1":"5.3","x2":"3","y2":"12.6","key":0}),React.createElement("g",{"key":1},[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t\t1.5,11.7 1.5,4.3 8,0.5 14.5,4.3 14.5,11.7 8,15.5 \t\t","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t\t4.5,6 4.5,10 8,12 11.5,10 11.5,6 8,4 \t\t","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"8","y1":"12","x2":"8","y2":"15.5","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"6.2","y1":"11.1","x2":"6.2","y2":"14.3","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.5","y1":"9.8","x2":"11.5","y2":"13.3","key":4}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.5","y1":"9.9","x2":"4.5","y2":"13.4","key":5}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.5","y1":"6","x2":"1.5","y2":"4.3","key":6}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.5","y1":"6","x2":"14.5","y2":"4.3","key":7}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.5","y1":"8","x2":"14.5","y2":"6.3","key":8}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.9","y1":"13.8","x2":"14.5","y2":"10","key":9}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.5","y1":"10","x2":"14.5","y2":"8.3","key":10}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.5","y1":"8","x2":"1.5","y2":"6.3","key":11}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.9","y1":"13.8","x2":"1.5","y2":"10","key":12}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"4.5","y1":"10","x2":"1.5","y2":"8.3","key":13}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.8","y1":"11","x2":"9.8","y2":"14.4","key":14}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"13","y1":"5.2","x2":"13","y2":"12.5","key":15})])]));
}

Releases.displayName = "Releases";

Releases.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Releases;

Releases.default = Releases;


/***/ }),

/***/ "../icon/src/icons/runs.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Runs (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"2.2","x2":"12.2","y2":"2.2","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"8","x2":"7.6","y2":"8","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"13.8","x2":"5.1","y2":"13.8","key":2}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t9,5.5 10.3,8.1 9.1,10.9 14.4,8.1 \t","key":3})]));
}

Runs.displayName = "Runs";

Runs.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Runs;

Runs.default = Runs;


/***/ }),

/***/ "../icon/src/icons/search.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"6.7","cy":"6.7","r":"5.8","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11","y1":"11.1","x2":"15.1","y2":"15.2","key":1})]));
}

Search.displayName = "Search";

Search.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Search;

Search.default = Search;


/***/ }),

/***/ "../icon/src/icons/settings.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Settings (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.1,7.6l-1.5-0.8c-0.2-0.7-0.5-1.4-0.9-2l0.5-1.5c0.1-0.3-0.2-0.6-0.5-0.5l-1.5,0.5c-0.6-0.4-1.3-0.7-2.1-0.9L8.4,0.9\n\t\tc-0.2-0.3-0.6-0.3-0.8,0L6.9,2.3C6.1,2.4,5.4,2.7,4.8,3.2L3.3,2.6C3,2.5,2.7,2.8,2.8,3.2l0.5,1.4C2.8,5.2,2.5,6,2.3,6.8L0.9,7.6\n\t\tc-0.3,0.2-0.3,0.6,0,0.8l1.4,0.8c0.1,0.7,0.4,1.4,0.8,2l-0.5,1.6c-0.1,0.3,0.2,0.6,0.5,0.5l1.6-0.5c0.6,0.4,1.3,0.7,2,0.8l0.7,1.4\n\t\tc0.2,0.3,0.6,0.3,0.8,0l0.7-1.4c0.9-0.1,1.7-0.5,2.3-0.9l1.5,0.5c0.3,0.1,0.6-0.2,0.5-0.5l-0.5-1.5c0.4-0.6,0.7-1.4,0.9-2.2\n\t\tl1.4-0.7C15.5,8.2,15.5,7.7,15.1,7.6z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"2.7","key":1})]));
}

Settings.displayName = "Settings";

Settings.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Settings;

Settings.default = Settings;


/***/ }),

/***/ "../icon/src/icons/signin.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Signin (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"opacity":"0.4","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15,4.3","key":0}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t3.1,3.7 3.1,1.3 15,1.3 15,14.7 3.1,14.7 3.1,13.4 \t","key":1}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t11.6,8 7.5,6 7.5,8 7.5,10.1 \t","key":2}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.4","y1":"8","x2":"1","y2":"8","key":3})]));
}

Signin.displayName = "Signin";

Signin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Signin;

Signin.default = Signin;


/***/ }),

/***/ "../icon/src/icons/size.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Size (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"2.4","rx":"7.2","ry":"1.6","key":0}),React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.6","rx":"7.2","ry":"1.6","key":1}),React.createElement("ellipse",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","rx":"7.2","ry":"1.3","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"0.8","y1":"2.4","x2":"0.8","y2":"13.6","key":3}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.2","y1":"13.6","x2":"15.2","y2":"2.4","key":4})]));
}

Size.displayName = "Size";

Size.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Size;

Size.default = Size;


/***/ }),

/***/ "../icon/src/icons/slack.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Slack (props) {
    return React.createElement("svg",props,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.3","y1":"3.9","x2":"2","y2":"8.6","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"17.4","y1":"10.4","x2":"4","y2":"15.1","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.2","y1":"4.3","x2":"7.9","y2":"17.5","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0..75","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"11.4","y1":"1.5","x2":"16.1","y2":"14.7","key":3})]);
}

Slack.displayName = "Slack";

Slack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 19 19","style":{"enableBackground":"new 0 0 19 19"},"xmlSpace":"preserve"};

module.exports = Slack;

Slack.default = Slack;


/***/ }),

/***/ "../icon/src/icons/stackOverflow.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function StackOverflow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM0.7,9.1l0,3.7c0,0.9,0.8,1.7,1.7,1.7l11,0c0.9,0,1.7-0.8,1.7-1.7","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"1.6","y1":"6.5","x2":"12.5","y2":"12.3","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2","y1":"3.5","x2":"14.2","y2":"9.6","key":2}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"3.7","y1":"1.4","x2":"15.3","y2":"7.4","key":3})]));
}

StackOverflow.displayName = "StackOverflow";

StackOverflow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = StackOverflow;

StackOverflow.default = StackOverflow;


/***/ }),

/***/ "../icon/src/icons/steps.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Steps (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M10.392.132L.1 5.816v11.369l10.292 5.684 10.292-5.684V5.817z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"transform":"translate(.44 .561)","key":0},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("g",{"fill":"currentColor","mask":"url(#b)","key":1},[React.createElement("path",{"d":"M32.363 27.184L9.299 14.464v-3.636l23.064 12.724c-.003 1.21.003 2.422 0 3.632","key":0}),React.createElement("path",{"d":"M9.299 10.83L-13.764-1.894l3.295-1.82L12.594 9.012 9.3 10.83zm26.396 10.921L12.632 9.031V5.394l23.063 12.724c-.003 1.21.003 2.422 0 3.632","key":1}),React.createElement("path",{"d":"M12.631 5.397L-10.432-7.327l3.296-1.82L15.927 3.578 12.63 5.397zM29.03 32.618L5.967 19.897v-3.635L29.03 28.985c-.003 1.21.003 2.423 0 3.633","key":2}),React.createElement("path",{"d":"M5.966 16.263L-17.097 3.54l3.296-1.82L9.262 14.446l-3.296 1.817z","key":3})])]),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M.283 5.952l-.256.142V18.03l.257.142 10.292 5.684.256.142.257-.142 10.292-5.684.257-.142V6.094l-.257-.141L11.089.268l-.257-.142-.257.142L.283 5.952zM10.575 1.12l10.292 5.684-.256-.425v11.368l.257-.425-10.292 5.684h.513L.797 17.321l.257.425V6.378l-.257.425L11.089 1.12h-.514z","key":1})])]);
}

Steps.displayName = "Steps";

Steps.defaultProps = {"width":"22","height":"24","viewBox":"0 0 22 24"};

module.exports = Steps;

Steps.default = Steps;


/***/ }),

/***/ "../icon/src/icons/tag.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Tag (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.4,1.2 13.6,1.2 13.6,14.8 7.9,11.9 2.4,14.7 \t"})));
}

Tag.displayName = "Tag";

Tag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Tag;

Tag.default = Tag;


/***/ }),

/***/ "../icon/src/icons/terminal.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Terminal (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"0.7","y":"0.8","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"14.4","height":"14.5","key":0}),React.createElement("polyline",{"fill":"none","stroke":"transparent","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.4,6 7.9,8 4.4,10 \t","key":1}),React.createElement("line",{"fill":"none","stroke":"transparent","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.7","y1":"12","x2":"11.8","y2":"12","key":2})]));
}

Terminal.displayName = "Terminal";

Terminal.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Terminal;

Terminal.default = Terminal;


/***/ }),

/***/ "../icon/src/icons/time.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Time (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.5,1.2C6.2,0.6,7,0.3,8,0.3c0.9,0,1.7,0.3,2.4,0.8","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8.3","r":"7.4","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t8,4.3 8,8.3 10.8,11.1 \t","key":2})]));
}

Time.displayName = "Time";

Time.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Time;

Time.default = Time;


/***/ }),

/***/ "../icon/src/icons/undo.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Undo (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8.3,3c1.5,0,3,0.6,4.2,1.7c2.3,2.3,2.3,6,0,8.2c-0.9,0.9-2.1,1.5-3.4,1.7c-0.3,0-0.5,0-0.8,0H1.9","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.2,3.4 8.2,5.4 8.2,3.4 8.2,1.4 \t","key":1})]));
}

Undo.displayName = "Undo";

Undo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Undo;

Undo.default = Undo;


/***/ }),

/***/ "../icon/src/icons/upload.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Upload (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.2,10.8c-1.4-0.3-2.4-1.5-2.4-2.9c0-1.6,1.2-2.9,2.8-3c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-2,1.5-3.7,3.5-3.8c0,0,0,0,0.1,0\n\t\tc2.5,0,3.4,1.9,3.4,1.9l0,0c0.2,0,0.4-0.1,0.6-0.1c2.2,0,4,1.8,4,4c0,2-1.5,3.7-3.4,4","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.2,6.5 5.2,10.5 7.2,10.5 9.2,10.5 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"10.5","x2":"7.2","y2":"14.9","key":2})]));
}

Upload.displayName = "Upload";

Upload.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Upload;

Upload.default = Upload;


/***/ }),

/***/ "../icon/src/icons/user.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function User (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"XMLID_315_","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,7.8","key":0}),React.createElement("g",{"key":1},[React.createElement("ellipse",{"id":"XMLID_118_","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"7.9","rx":"4","ry":"4","key":0}),React.createElement("path",{"id":"XMLID_117_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeMiterlimit":"10","d":"M1.2,11\n\t\t\tC0.9,10.1,0.5,9.1,0.5,8c0-4.2,3.4-7.7,7.5-7.7s7.5,3.4,7.5,7.7c0,1-0.3,2.1-0.7,2.9","key":1}),React.createElement("path",{"id":"XMLID_103_","fill":"currentColor","d":"M15.2,15.1c0,0,0.4-3.3-1.2-3.3h-1.4c-0.6,0-0.7,0.3-0.8,0.4c-0.5,1-1.6,1.5-2.7,1.5H6.9\n\t\t\tc-1.1,0-2.3-0.5-2.7-1.5c-0.1-0.1-0.2-0.4-0.8-0.4H2.1c-1.6,0-1.2,3.3-1.2,3.3s1.3,0.8,7.2,0.8S15.2,15.1,15.2,15.1z","key":2})])]));
}

User.displayName = "User";

User.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = User;

User.default = User;


/***/ }),

/***/ "../icon/src/icons/workflow.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function Workflow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"2","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM9.5,7.9","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM1.2,6.7","key":2}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"2.6","cy":"5.4","r":"1.4","key":3}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"13.4","cy":"10.6","r":"1.4","key":4}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.9,4.7c2.5-1.3,6.7-3.7,7.8-3.9c1.2-0.2,3.9,2.4,1.4,4.2l-3,2.4","key":5}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM12.1,11.3c-2.5,1.3-6.7,3.6-7.7,3.8c-1.3,0.2-3.9-2.4-1.4-4.2L6,8.6","key":6})]));
}

Workflow.displayName = "Workflow";

Workflow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Workflow;

Workflow.default = Workflow;


/***/ }),

/***/ "../icon/src/icons/xMark.svg":
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__("react");

function XMark (props) {
    return React.createElement("svg",props,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeMiterlimit":"10","x1":"13.5","y1":"2.5","x2":"2.5","y2":"13.5","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeMiterlimit":"10","x1":"2.5","y1":"2.5","x2":"13.5","y2":"13.5","key":1})]);
}

XMark.displayName = "XMark";

XMark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = XMark;

XMark.default = XMark;


/***/ }),

/***/ "../icon/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _add_user = __webpack_require__("../icon/src/icons/add_user.svg");

Object.defineProperty(exports, 'AddUser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_add_user).default;
  }
});

var _alarm = __webpack_require__("../icon/src/icons/alarm.svg");

Object.defineProperty(exports, 'Alarm', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_alarm).default;
  }
});

var _application = __webpack_require__("../icon/src/icons/application.svg");

Object.defineProperty(exports, 'Application', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_application).default;
  }
});

var _archive = __webpack_require__("../icon/src/icons/archive.svg");

Object.defineProperty(exports, 'Archive', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_archive).default;
  }
});

var _arrow = __webpack_require__("../icon/src/icons/arrow.svg");

Object.defineProperty(exports, 'Arrow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arrow).default;
  }
});

var _at = __webpack_require__("../icon/src/icons/at.svg");

Object.defineProperty(exports, 'At', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_at).default;
  }
});

var _bitbucket = __webpack_require__("../icon/src/icons/bitbucket.svg");

Object.defineProperty(exports, 'Bitbucket', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bitbucket).default;
  }
});

var _burgerMenu = __webpack_require__("../icon/src/icons/burgerMenu.svg");

Object.defineProperty(exports, 'BurgerMenu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_burgerMenu).default;
  }
});

var _cards = __webpack_require__("../icon/src/icons/cards.svg");

Object.defineProperty(exports, 'Cards', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cards).default;
  }
});

var _checkMark = __webpack_require__("../icon/src/icons/checkMark.svg");

Object.defineProperty(exports, 'CheckMark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkMark).default;
  }
});

var _cluster = __webpack_require__("../icon/src/icons/cluster.svg");

Object.defineProperty(exports, 'Cluster', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cluster).default;
  }
});

var _code = __webpack_require__("../icon/src/icons/code.svg");

Object.defineProperty(exports, 'Code', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_code).default;
  }
});

var _comment = __webpack_require__("../icon/src/icons/comment.svg");

Object.defineProperty(exports, 'Comment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_comment).default;
  }
});

var _copyClipboard = __webpack_require__("../icon/src/icons/copyClipboard.svg");

Object.defineProperty(exports, 'CopyClipboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_copyClipboard).default;
  }
});

var _cpu = __webpack_require__("../icon/src/icons/cpu.svg");

Object.defineProperty(exports, 'Cpu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cpu).default;
  }
});

var _delete = __webpack_require__("../icon/src/icons/delete.svg");

Object.defineProperty(exports, 'Delete', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_delete).default;
  }
});

var _devCenter = __webpack_require__("../icon/src/icons/devCenter.svg");

Object.defineProperty(exports, 'DevCenter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_devCenter).default;
  }
});

var _docs = __webpack_require__("../icon/src/icons/docs.svg");

Object.defineProperty(exports, 'Docs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_docs).default;
  }
});

var _download = __webpack_require__("../icon/src/icons/download.svg");

Object.defineProperty(exports, 'Download', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_download).default;
  }
});

var _edit = __webpack_require__("../icon/src/icons/edit.svg");

Object.defineProperty(exports, 'Edit', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_edit).default;
  }
});

var _environment = __webpack_require__("../icon/src/icons/environment.svg");

Object.defineProperty(exports, 'Environment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_environment).default;
  }
});

var _exclamationmark = __webpack_require__("../icon/src/icons/exclamationmark.svg");

Object.defineProperty(exports, 'Exclamationmark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_exclamationmark).default;
  }
});

var _exclamationMarkSolid = __webpack_require__("../icon/src/icons/exclamationMarkSolid.svg");

Object.defineProperty(exports, 'ExclamationMarkSolid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_exclamationMarkSolid).default;
  }
});

var _explore = __webpack_require__("../icon/src/icons/explore.svg");

Object.defineProperty(exports, 'Explore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_explore).default;
  }
});

var _fail = __webpack_require__("../icon/src/icons/fail.svg");

Object.defineProperty(exports, 'Fail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fail).default;
  }
});

var _filtering = __webpack_require__("../icon/src/icons/filtering.svg");

Object.defineProperty(exports, 'Filtering', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_filtering).default;
  }
});

var _flag = __webpack_require__("../icon/src/icons/flag.svg");

Object.defineProperty(exports, 'Flag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_flag).default;
  }
});

var _github = __webpack_require__("../icon/src/icons/github.svg");

Object.defineProperty(exports, 'Github', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_github).default;
  }
});

var _group = __webpack_require__("../icon/src/icons/group.svg");

Object.defineProperty(exports, 'Group', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_group).default;
  }
});

var _ideasBox = __webpack_require__("../icon/src/icons/ideasBox.svg");

Object.defineProperty(exports, 'IdeasBox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ideasBox).default;
  }
});

var _learn = __webpack_require__("../icon/src/icons/learn.svg");

Object.defineProperty(exports, 'Learn', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_learn).default;
  }
});

var _links = __webpack_require__("../icon/src/icons/links.svg");

Object.defineProperty(exports, 'Links', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_links).default;
  }
});

var _list = __webpack_require__("../icon/src/icons/list.svg");

Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_list).default;
  }
});

var _location = __webpack_require__("../icon/src/icons/location.svg");

Object.defineProperty(exports, 'Location', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_location).default;
  }
});

var _logout = __webpack_require__("../icon/src/icons/logout.svg");

Object.defineProperty(exports, 'Logout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_logout).default;
  }
});

var _machineType = __webpack_require__("../icon/src/icons/machineType.svg");

Object.defineProperty(exports, 'MachineType', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_machineType).default;
  }
});

var _marketplace = __webpack_require__("../icon/src/icons/marketplace.svg");

Object.defineProperty(exports, 'Marketplace', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_marketplace).default;
  }
});

var _master = __webpack_require__("../icon/src/icons/master.svg");

Object.defineProperty(exports, 'Master', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_master).default;
  }
});

var _memory = __webpack_require__("../icon/src/icons/memory.svg");

Object.defineProperty(exports, 'Memory', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_memory).default;
  }
});

var _nodes = __webpack_require__("../icon/src/icons/nodes.svg");

Object.defineProperty(exports, 'Nodes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nodes).default;
  }
});

var _options = __webpack_require__("../icon/src/icons/options.svg");

Object.defineProperty(exports, 'Options', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_options).default;
  }
});

var _organization = __webpack_require__("../icon/src/icons/organization.svg");

Object.defineProperty(exports, 'Organization', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_organization).default;
  }
});

var _padlock = __webpack_require__("../icon/src/icons/padlock.svg");

Object.defineProperty(exports, 'Padlock', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_padlock).default;
  }
});

var _pipeline = __webpack_require__("../icon/src/icons/pipeline.svg");

Object.defineProperty(exports, 'Pipeline', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pipeline).default;
  }
});

var _plus = __webpack_require__("../icon/src/icons/plus.svg");

Object.defineProperty(exports, 'Plus', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_plus).default;
  }
});

var _refresh = __webpack_require__("../icon/src/icons/refresh.svg");

Object.defineProperty(exports, 'Refresh', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_refresh).default;
  }
});

var _releases = __webpack_require__("../icon/src/icons/releases.svg");

Object.defineProperty(exports, 'Releases', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_releases).default;
  }
});

var _runs = __webpack_require__("../icon/src/icons/runs.svg");

Object.defineProperty(exports, 'Runs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_runs).default;
  }
});

var _search = __webpack_require__("../icon/src/icons/search.svg");

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_search).default;
  }
});

var _settings = __webpack_require__("../icon/src/icons/settings.svg");

Object.defineProperty(exports, 'Settings', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_settings).default;
  }
});

var _signin = __webpack_require__("../icon/src/icons/signin.svg");

Object.defineProperty(exports, 'Signin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_signin).default;
  }
});

var _size = __webpack_require__("../icon/src/icons/size.svg");

Object.defineProperty(exports, 'Size', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_size).default;
  }
});

var _stackOverflow = __webpack_require__("../icon/src/icons/stackOverflow.svg");

Object.defineProperty(exports, 'StackOverflow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stackOverflow).default;
  }
});

var _slack = __webpack_require__("../icon/src/icons/slack.svg");

Object.defineProperty(exports, 'Slack', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_slack).default;
  }
});

var _steps = __webpack_require__("../icon/src/icons/steps.svg");

Object.defineProperty(exports, 'Steps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_steps).default;
  }
});

var _tag = __webpack_require__("../icon/src/icons/tag.svg");

Object.defineProperty(exports, 'Tag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tag).default;
  }
});

var _terminal = __webpack_require__("../icon/src/icons/terminal.svg");

Object.defineProperty(exports, 'Terminal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_terminal).default;
  }
});

var _time = __webpack_require__("../icon/src/icons/time.svg");

Object.defineProperty(exports, 'Time', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_time).default;
  }
});

var _undo = __webpack_require__("../icon/src/icons/undo.svg");

Object.defineProperty(exports, 'Undo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_undo).default;
  }
});

var _upload = __webpack_require__("../icon/src/icons/upload.svg");

Object.defineProperty(exports, 'Upload', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_upload).default;
  }
});

var _user = __webpack_require__("../icon/src/icons/user.svg");

Object.defineProperty(exports, 'User', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_user).default;
  }
});

var _workflow = __webpack_require__("../icon/src/icons/workflow.svg");

Object.defineProperty(exports, 'Workflow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_workflow).default;
  }
});

var _xMark = __webpack_require__("../icon/src/icons/xMark.svg");

Object.defineProperty(exports, 'XMark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_xMark).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.js